import { graphql } from 'react-relay/legacy';
import { defineMessages } from 'dibs-react-intl';
import get from 'lodash.get';

const productionTimeNotes = defineMessages({
    offerAndShipping: {
        id: 'bomt.BuyerOmtItem.productionTimeNote.offerAndShipping',
        defaultMessage:
            'Production will begin after your offer is accepted and the order is confirmed.',
    },
    offerAndNoShipping: {
        id: 'bomt.BuyerOmtItem.productionTimeNote.offerAndNoShipping',
        defaultMessage:
            'Production will begin after your offer is accepted and any shipping quotes have been approved.',
    },
    noOfferAndShipping: {
        id: 'bomt.BuyerOmtItem.productionTimeNote.noOfferAndShipping',
        defaultMessage: 'Production will begin after your order is confirmed.',
    },
    noOfferAndNoShipping: {
        id: 'bomt.BuyerOmtItem.productionTimeNote.noOfferAndNoShipping',
        defaultMessage:
            'Production will begin after any shipping quotes are approved and your order is confirmed.',
    },
});

const productionTimeNotesPart = defineMessages({
    offerAndShipping: {
        id: 'bomt.BuyerOmtItem.productionTimeNotePart.offerAndShipping',
        defaultMessage: 'which will begin after your offer is accepted and the order is confirmed.',
    },
    offerAndNoShipping: {
        id: 'bomt.BuyerOmtItem.productionTimeNotePart.offerAndNoShipping',
        defaultMessage:
            'which will begin after your offer is accepted and any shipping quotes have been approved.',
    },
    noOfferAndShipping: {
        id: 'bomt.BuyerOmtItem.productionTimeNotePart.noOfferAndShipping',
        defaultMessage: 'which will begin after your order is confirmed.',
    },
    noOfferAndNoShipping: {
        id: 'bomt.BuyerOmtItem.productionTimeNotePart.noOfferAndNoShipping',
        defaultMessage:
            'which will begin after any shipping quotes are approved and your order is confirmed.',
    },
});

function productionTimeNote({ transaction, hideOnFullPriceOrder, hideOnOffer }, message) {
    const isFullPriceOrder = hideOnFullPriceOrder ? false : get(transaction, 'isFullPriceOrder');
    const isNegotiable = hideOnOffer ? false : get(transaction, 'isNegotiable');
    const isShippingKnownAtCheckout = get(transaction, 'isShippingKnownAtCheckout');

    if (isNegotiable && isShippingKnownAtCheckout) {
        return message.offerAndShipping;
    } else if (isNegotiable && !isShippingKnownAtCheckout) {
        return message.offerAndNoShipping;
    } else if (isFullPriceOrder && isShippingKnownAtCheckout) {
        return message.noOfferAndShipping;
    } else if (isFullPriceOrder && !isShippingKnownAtCheckout) {
        return message.noOfferAndNoShipping;
    }
    return '';
}

export const getProductionTimeNotePart = ({ transaction, hideOnOffer }) =>
    productionTimeNote({ transaction, hideOnOffer }, productionTimeNotesPart);
export const getProductionTimeNote = ({ transaction, hideOnFullPriceOrder }) =>
    productionTimeNote({ transaction, hideOnFullPriceOrder }, productionTimeNotes);

export const productionTimeNoteFragment = graphql`
    fragment productionTimeNoteHelper_transaction on Transaction {
        isFullPriceOrder
        isNegotiable
        isShippingKnownAtCheckout
    }
`;
